import React from 'react';

const ModalDialog = ({ show, title, message, icon, onClose }) => {
    if (!show) return null;

    return (
        <div className="modal show d-block fade dialogbox" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className={`modal-icon text-${icon === 'checkmark-circle' ? 'success' : 'danger'}`}>
                        <ion-icon name={icon}></ion-icon>
                    </div>
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                    </div>
                    <div className="modal-body">
                        {message}
                    </div>
                    <div className="modal-footer">
                        <div className="btn-inline">
                            <a href="#" className="btn" data-bs-dismiss="modal" onClick={onClose}>CLOSE</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalDialog;
